import Typography from '@mui/material/Typography';
import { POSITIONAL_SUFFIXES } from 'src/util/suffixes';

export type RankProps = {
  rank: number;
};

export const Rank = ({ rank }: RankProps) => {
  const ordinalFormat = new Intl.PluralRules('en', { type: 'ordinal' }).select(
    rank,
  );

  return (
    <Typography
      variant={rank > 3 ? 'body2' : 'body1'}
      {...(rank <= 3 && { sx: { fontWeight: 700 } })}
    >
      {rank + POSITIONAL_SUFFIXES[ordinalFormat as keyof typeof POSITIONAL_SUFFIXES]}
    </Typography>
  );
};
